import React, { useContext } from 'react';
import Dropdown from '@prisjakt/ui-dropdown-new';
import DropdownItem from '@prisjakt/ui-dropdown-new/src/item';
import {
  ParamsAndReturnTypes,
  TranslateFunc,
} from '@prisjakt/ui-translate/src/translate-func';
import { AppContext } from '@prisjakt/ui-app-context';
import { GroupOption, GroupOptionEnum } from './types';
import * as S from './styles';
import * as ST from '../styles';

const GroupOptions: React.FC<OwnProps> = props => {
  const {
    compact,
    setCurrentGrouping,
    currentGrouping = GroupOptionEnum.GROUP_ON_PARTNERS,
  } = props;

  const { t } = useContext(AppContext);
  const groupOptions = [
    GroupOptionEnum.GROUP_ON_PARTNERS,
    GroupOptionEnum.NO_GROUPING,
  ];

  const group = (selectedGrouping: GroupOption) => {
    if (currentGrouping === selectedGrouping) return null;

    return setCurrentGrouping(selectedGrouping);
  };

  const getGroupOptions = () =>
    compact
      ? groupOptions
      : groupOptions.filter(groupOption => groupOption !== currentGrouping);

  const toggleElement = () => (
    <S.GroupingOptionsButton variant="text" color="primary">
      <ST.TabletDesktop>
        <S.ButtonText>{translateOption(t, currentGrouping)}</S.ButtonText>
      </ST.TabletDesktop>
      <ST.OnlyMobile>
        <S.GroupIconComponent />
      </ST.OnlyMobile>
    </S.GroupingOptionsButton>
  );

  return (
    <S.GroupingOptions>
      <ST.TabletDesktop>{t('common', 'sort.title')}:&nbsp;</ST.TabletDesktop>
      <Dropdown
        grow="right"
        toggleElement={toggleElement()}
        variant="secondary"
        showArrow={!compact}
      >
        {getGroupOptions().map(groupOption => {
          const title = translateOption(t, groupOption);
          return compact ? (
            <S.RadioItem
              key={groupOption}
              name="radioSelection"
              id={groupOption}
              checked={groupOption === currentGrouping}
              current={groupOption === currentGrouping}
              onChange={() => group(groupOption)}
            >
              {title}
            </S.RadioItem>
          ) : (
            <DropdownItem
              key={groupOption}
              data-test="PriceGroupOption"
              onClick={() => group(groupOption)}
            >
              {title}
            </DropdownItem>
          );
        })}
      </Dropdown>
    </S.GroupingOptions>
  );
};

function translateOption(t: TranslateFunc, groupOption: GroupOptionEnum) {
  return t(
    'common',
    `group.${groupOption.toLowerCase()}` as keyof ParamsAndReturnTypes['common']
  );
}

type OwnProps = {
  compact?: boolean;
  setCurrentGrouping: (currentGroup: GroupOption) => void;
  currentGrouping: GroupOption;
};

export default GroupOptions;
